module.exports = __webpack_public_path__ + "img/confetti_3d.612b25dd.svg";